// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".stamp-overLay .no-presets{color:var(--no-presets-text);display:flex;justify-content:center;align-items:center;width:100%}", ""]);
// Exports
module.exports = exports;
